import { AnsweringClient } from "../../clients/answeringClient";

export interface ReimburseLicenseModalControllerDelegate {
  didReimburseLicenses: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
}

export class ReimburseLicenseModalController {
  constructor(
    private delegate: ReimburseLicenseModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  /**
   * Tenta executar o ressarcimento de licenças para uma aplicação.
   * * @param {string} accessToken O token de acesso do usuário.
   * @param {number} applicationId O ID da aplicação a ser ressarcida.
   */
  public async reimburseLicenses(accessToken: string, applicationId: number) {
    try {
      await this.answeringClient.reimburseLicenses(accessToken, applicationId);
      this.delegate.didReimburseLicenses();
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.reimburseLicenses(newTokens.accessToken, applicationId);
        return;
      }
      this.delegate.genericError();
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
